'use strict';
define([
	'../../../base/PureComponent',
	'../../../misc/AppEvents',
	'../../../misc/AppEvent',
	'../../../g2',
	'../../PlotSchema'
], function(PureComponent, AppEvents, AppEvent,g2,PlotSchema) {
    /**
     * @constructor
     * @classdesc 协同标绘组件
     * @augments G.base.PureComponent
     * @alias G.plot.CollaborativePlotComponent
     * @param options {Object} 必填
     * @param options.map {G.Map} 必填，地图对象
     */
	var collaborativePlot = PureComponent.extend({
		options: {
			title: '协同标绘组件'
		},
		includes: AppEvent.prototype,
		initialize: function(options) {
			PureComponent.prototype.initialize.call(this, options);
			//初始化图层组
			this._initLayersGroup();
			//反序列化标绘用
			this._deserializer = new g2.core.Deserializer();
		},
		/*
		 * 销毁，对应initialize
		 * */
		destroy: function() {
			//销毁组件
			PureComponent.prototype.destroy.call(this);
		}
	})
	/**
	 * 展示数据前的初始化
	 * */
	collaborativePlot.include({
		/**
		 * 初始化图层组
		 * */
		_initLayersGroup: function() {
			var group = new g2.carto.GroupLayer({
				id: "syncLayerGroup",
				name: "同步数据的图层组",
				layers: []
			});
			this.map.getMap().addLayer(group);
			this._groupLayer = group;
			//保存所有的图层
			this._layers = {};
			//标绘图层组
			var syncPlotLayerGroup = new g2.carto.GroupLayer({
				layers: []
			});
			group.addLayer(syncPlotLayerGroup);
			this._collaborativePlotLayerGroup = syncPlotLayerGroup;
		},
		/**
		 * 获取同步的标绘图层
		 * @method
		 * @param options
		 * options.memberId 对应数据库表中用户的id
		 * @private
		 */
		_getPlotSyncLayer: function(options) {
			options.type = '_collaborativePlotLayerGroup';
			return this._getSyncLayer(options)
		},
        /**
         * 获取同步的标绘图层
         * @param options
         * options.memberId 对应数据库表中用户的id
         * options.type
         * @private
         */
		_getSyncLayer: function(options) {
			var type = options.type;
			var layerId = type.toLowerCase() + '-' + options.memberId;
			var layer = null;
			layer = this._layers[layerId];
			if(!layer) {
				layer = new g2.carto.ElementLayer({
					id: layerId,
					map: this.map.getMap()
				});
				this[type].addLayer(layer);
				this._layers[layerId] = layer;
			}
			return layer;
		},
	})
	/**
	 * 协同标绘对外调用
	 * */
	collaborativePlot.include({
        /**
         * 开始协同标绘
         * @method
         * @memberOf G.plot.CollaborativePlotComponent.prototype
         */
		startCollaborativePlot: function() {
			console.log('开始协同标绘');
			var self = this;
			//添加标绘的回调
			this.plotCreatedCallback = function(event) {
				var plotElement = event.element;
				var type = event.type;
				self._addPlot(plotElement);
			}
			//更新标绘的监听
			this.plotUpdateCallback = function(event) {
				var plotElement = event.element;
				self._updatePlot(plotElement);
			}
			//删除标绘的监听
			this.plotDeleteCallback = function(event) {
				var plotElements = event.elements;
				self._deletePlot(plotElements);
			}
			//开始监听添加标绘
			this.map.listen(AppEvents.PLOT_CREATED, this.plotCreatedCallback);
			//开始监听更新标绘
			this.map.listen(AppEvents.PLOT_UPDATED, this.plotUpdateCallback);
			//开始监听删除标绘
			this.map.listen(AppEvents.PLOT_DELETE, this.plotDeleteCallback)
		},
        /**
         * 结束协同标绘
         * @method
         * @memberOf G.plot.CollaborativePlotComponent.prototype
         */
		endCollaborativePlot: function() {
			console.log('结束协同标绘');
			var self = this;
			//结束监听添加标绘
			this.map.off(AppEvents.PLOT_CREATED, this.plotCreatedCallback);
			//结束监听更新标绘
			this.map.off(AppEvents.PLOT_UPDATED, this.plotUpdateCallback);
			//结束监听删除标绘
			this.map.off(AppEvents.PLOT_DELETE, this.plotDeleteCallback);
		},
        /**
         * 解析标绘数据
         * @method
         * @memberOf G.plot.CollaborativePlotComponent.prototype
         * @param options {Object} 必填
         * @param options.memberId {String} 必填 同步标绘用户的唯一标识
         * @param options.data {Object} 必填 需要解析的标绘数据
		 */
		analysisSyncPlot: function(options) {
			var msg = "";
			var dataId = "";
			var data = options.data;
			var memberId = options.memberId;
			var mergeData = [];
			var opt = {}
			if(memberId && data) {
				var layer = this._getPlotSyncLayer({
					memberId: memberId
				});
				var plotEleArr = this._deserializePlotElement(data);
				if(plotEleArr) {
					this['_' + data.name + 'OnLayer'](plotEleArr, layer);
				}
				msg = "数据解析成功!";
			} else {
				msg = "数据解析失败!成员标识或者数据不全";
			}
			var opts = {
				msg: msg,
				dataId: dataId
			}
			return opts;
		},
        /**
         * 清除某用户或全部的图层
         * @method
         * @memberOf G.plot.CollaborativePlotComponent.prototype
         * @param memberId {String}  可选 需要清除成员的标识,如果不传清除所有
         */
		clearSpecifyOrAllPlot: function(memberId) {
			if(memberId) {
				var memberIds = memberId.split(",");
				if(memberIds.length > 0) {
					for(var i = 0; i < memberIds.length; i++) {
						var layer = this._getPlotSyncLayer({
							memberId: memberIds[i]
						});
						layer.clear();
					}
				}
			} else {
				for(var k in this._layers) {
					if(k.indexOf("_collaborativePlotLayerGroup") >= 0) {
						this._layers[k].clear();
					}
				}
				this._syncPlotLayerGroup.clear();
			}
		},
        /**
         * 显隐某用户或全部的图层
         * @method
         * @memberOf G.plot.CollaborativePlotComponent.prototype
         * @param memberId {String} 可选，需要显隐某用户数据的唯一标识,如果不传显/隐所有
         * @param visible {Boolean} 必填 true显示 false隐藏
		 */
		visibleSpecifyOrAllPlot: function(memberId, visible) {
			if(visible == undefined) {
				return;
			}
			if(memberId) {
				var memberIds = memberId.split(",");
				if(memberIds.length > 0) {
					for(var i = 0; i < memberIds.length; i++) {
						var layer = this._getPlotSyncLayer({
							memberId: memberIds[i]
						});
						layer.setVisible(visible);
					}
				}
			} else {
				this._syncPlotLayerGroup.setVisible(visible);
			}
		}
	})
	collaborativePlot.include({
		/**
		 * 添加协同标绘
		 * @param {g2.sfs.Element} ele 标绘的点元素
		 * */
		_addPlot: function(ele) {
			var schema = new PlotSchema({
				id: new Date().toString(),
				name: "addPlot"
			});
			var element = ele.copy();
			element.unReset();
			element.id = ele.id;
			schema.addElement(element)
			this.fire(AppEvents.COLLABORATIVE_PLOT_CREATED, {
				data: schema
			});
		},
		/**
		 * 更新标绘
		 * @param {g2.sfs.Element} ele 标绘的点元素
		 * */
		_updatePlot: function(ele) {
			var schema = new PlotSchema({
				id: new Date().toString(),
				name: "updatePlot"
			});
			var element = ele.copy();
			element.unReset();
			element.id = ele.id;
			schema.addElement(element);
			this.fire(AppEvents.COLLABORATIVE_PLOT_UPDTAED, {
				data: schema
			});
		},
		/**
		 * 删除标绘
		 * @param {g2.sfs.Elements} eles 标绘的点元素集合
		 * */
		_deletePlot: function(eles) {
			var schema = new PlotSchema({
				id: new Date().toString(),
				name: "deletePlot"
			});
			for(var i = 0; i < eles.length; i++) {
				var element = eles[i].copy();
				element.unReset();
				element.id = eles[i].id;
				schema.addElement(element);
			}
			this.fire(AppEvents.COLLABORATIVE_PLOT_DELETE, {
				data: schema
			});
		}
	})
	/**
	 * 展示不同操作的数据到地图
	 * */
	collaborativePlot.include({
		/**
		 * 添加元素到地图图层
		 * @param {g2.sfs.Elements} eles 要添加的标绘元素集合
		 * @param {g2.lys.ElementLayer} layer 要操作的图层
		 * */
		_addPlotOnLayer: function(eles, layer) {
			if(layer && eles[0]) {
				layer.add(eles[0]);
			}
		},
		/**
		 * 更新标绘到地图图层
		 * @param {g2.sfs.Elements} eles 要更新的标绘元素集合
		 * @param {g2.lys.ElementLayer} layer 要操作的图层
		 * */
		_updatePlotOnLayer: function(eles, layer) {
			//标绘图层里不包含
			if(layer && eles[0]) {
				if(layer.contains(eles[0].id)) {
					var element = layer.find(eles[0].id);
					layer.remove(element);
					layer.add(eles[0]);
				}
			}
		},
		/**
		 * 删除标绘在地图图层
		 * @param {g2.sfs.Elements} eles 要删除的标绘元素集合
		 * @param {g2.lys.ElementLayer} layer 要操作的图层
		 * */
		_deletePlotOnLayer: function(eles, layer) {
			if(eles.length > 0 && layer) {
				for(var i = 0; i < eles.length; i++) {
					if(layer.contains(eles[i].id)) {
						var element = layer.find(eles[i].id);
						layer.remove(element);
					}
				}
			}
		},
		/**
		 * 反序列化标绘元素
		 * @param {String} obj g2.plot. PlotSchema字符串对象
		 * @return {Array} elements 标绘元素数据
		 * */
		_deserializePlotElement: function(obj) {
			var elements = [];
			var schema = this._deserializer.createJsInstance(obj);
			if(!!schema) {
				for(var i = 0; i < schema.getCount(); i++) {
					var element = schema.getElement(i);
					element.reset()
					elements.push(element)
				}
			}
			return elements;
		},
	})
	return collaborativePlot;
})
